import { UniDriver } from '@wix/unidriver-core';
import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

export type BoxUniDriver = BaseUniDriver;

export const boxDriverFactory = (base: UniDriver): BoxUniDriver => {
  return {
    ...baseUniDriverFactory(base),
  };
};
